import { Logger } from '~~/helpers/logger';
import { CHUNK_LOAD_RETRIES } from '~~/constants/localStorage';
import { CHUNK_PATH } from '~~/constants/regex';

export default defineNuxtPlugin(() => {

  const MAX_CHUNK_RETRIES = 2;
  function reloadPageWithRetryLimit() {

    const count = Number(localStorage.getItem(CHUNK_LOAD_RETRIES) || 0);

    if (count < MAX_CHUNK_RETRIES) {

      localStorage.setItem(CHUNK_LOAD_RETRIES, String(count + 1));
      window.location.reload();
    
    } else {

      Logger.warn('Chunk load retry limit reached');
      localStorage.removeItem(CHUNK_LOAD_RETRIES);
    
    }
  
  }

  if (import.meta.client) {

    const head = document.getElementsByTagName('head')?.[0];

    if (!head) {

      return;

    }

    const originalAppendChild = head.appendChild;
    head.appendChild = function(element) {

      if (
        element.tagName === 'SCRIPT' &&
        CHUNK_PATH.test(element.src)
      ) {

        element.onerror = () => {

          Logger.warn('Chunk load error on', element.src);
          reloadPageWithRetryLimit();
        
        };
      
      }

      return originalAppendChild.call(this, element);
    
    };
  
  }

});
